export default "__VITE_ASSET__BKPxQFh___"